import * as yup from 'yup';
import { translate } from '../../../shared/i18n';

export const schemaFinancialPlanCreate = yup.object().shape({
  description: yup
    .string()
    .required(translate('financialPlansModal.validation.descriptionRequired')),
});

export const schemaFinancialPlanEdit = yup.object().shape({
  description: yup
    .string()
    .required(translate('financialPlansModal.validation.descriptionRequired')),
  status: yup
    .boolean()
    .required(translate('financialPlansModal.validation.statusRequired')),
});
